import { camelCase, omitBy, isNil, find } from 'lodash';
import useRefreshToken from 'Hooks/refresh-token.hook';

import fieldMap from './field-map.json';
import errors from './errors.json';
import cmsErrors from './errors-cms.json';

const ApiResponseException = async (
  error: { [key: string]: any },
  opt?: {
    callback?: () => Promise<void>,
    noRedirect?: boolean
  }
) => {
  let errorMessage = '';
  let stack = {};

  if (error.type === 'UNAUTHORIZED') {
    const isRefreshSuccess = await useRefreshToken(opt?.noRedirect);

    if (isRefreshSuccess && opt?.callback) await opt.callback();
    return omitBy({ ...error, value: errorMessage, stack }, isNil)
  }
  else if (error.type === 'VALIDATION_ERROR') {
    let { message, type, field } = error.message;

    const fieldList = fieldMap;
    field = fieldList[field] || null;

    if (isNil(field) || field !== '') {
      if (type?.includes('empty') || type?.includes('required')) {
        errorMessage = 'error.required';
      } else if (
        type?.includes('base') ||
        type?.includes('pattern') ||
        type?.includes('alternatives.match')
      ) {
        errorMessage = 'error.pattern';
      } else if (type?.includes('min')) {
        errorMessage = 'error.min';
      } else if (type?.includes('max')) {
        errorMessage = 'error.max';
      } else if (type?.includes('length')) {
        errorMessage = 'error.length';
      } else if (type?.includes('only')) {
        errorMessage = 'error.only';
      } else if (type?.includes('array.unique')) {
        errorMessage = 'error.unique';
      } else if (type?.includes('array.includesRequiredUnknowns')) {
        errorMessage = 'error.oneRequired';
      } else if (type?.includes('oneOf') && message?.includes('Ref')) {
        const regExp = /\(([^)]+)\)/;
        const matches = regExp.exec(message);

        errorMessage = matches ? `error.ref.${matches[1]}` : 'error.ref';
      }
    } else {
      errorMessage = 'error.validationFailed';
    }

    return omitBy({ ...error, value: errorMessage, stack: { ...stack, field } }, isNil);
  } else {
    const matchedError = find(errors, (e: any) => e.code === error.code);
    let errorMessage = matchedError?.message;
    let errorType = matchedError?.type;
    let field = matchedError?.field;

    if (!matchedError) {
      errorMessage = `error.${camelCase(error.type)}`;
    }

    return omitBy(
      {
        ...error,
        value: errorMessage,
        type: errorType,
        stack: { ...stack, field },
      },
      isNil
    );
  }
};

export default ApiResponseException;

export const CmsApiResponseException = (code: string) => {
  let status = 'error';

  const matchedError = find(cmsErrors, (e: any) => e.code === code);
  let errorMessage = matchedError?.errorMessage;
  let message = matchedError?.message;

  if (!matchedError) {
    errorMessage = 'error.internalServerError';
    message = 'Internal Server Error';
  }

  return omitBy(
    {
      error: {
        status,
        value: errorMessage,
        code,
        message,
      },
    },
    isNil
  );
};
